import { render, staticRenderFns } from "./FormButton.vue?vue&type=template&id=f80f1f64&scoped=true"
import script from "./FormButton.vue?vue&type=script&lang=js"
export * from "./FormButton.vue?vue&type=script&lang=js"
import style0 from "./FormButton.vue?vue&type=style&index=0&id=f80f1f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../imicsspa/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80f1f64",
  null
  
)

export default component.exports